import React from 'react';
import classNames from 'classnames';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import Edit3Icon from '../../../../design-system/Icons/Edit3Icon';
import MoreInfoModal from '../MoreInfoModal/MoreInfoModal';
import { SvgIcon } from '../../../../design-system';

const InfoTag = ({ type, data, setData, isEditable }) => {
    const { label, value, is_required } = data || {};

    const { isOpened, open: openModal, close: closeModal } = useOverlayState();

    const state = is_required && !value ? 'error' : 'filled';

    const tagClassName = classNames(
        'max-w-full w-fit min-h-[36px] px-2 py-1 rounded-2 flex items-center gap-2 overflow-hidden',
        {
            'bg-neutral-100': state === 'filled',
            'bg-red-100': state === 'error',
        }
    );

    const color = {
        filled: '#1F2125',
        error: '#E95B69',
    }[state];

    return (
        <>
            <button className={tagClassName} onClick={openModal}>
                <p className="font-body text-body-regular-s truncate" style={{ color }}>
                    <span className="font-body-bold text-body-bold-s uppercase">{type}: </span>
                    {label}
                </p>

                {isEditable && (
                    <div className="w-[28px] h-[28px] min-w-[28px] flex items-center justify-center">
                        <SvgIcon icon={Edit3Icon} size="medium" color={color} />
                    </div>
                )}
            </button>

            {isOpened && (
                <MoreInfoModal
                    type={type}
                    data={data}
                    setData={setData}
                    isEditable={isEditable}
                    onClose={closeModal}
                />
            )}
        </>
    );
};

export default InfoTag;
